import "../scss/account-form.scss";
import { togglePasswordVisibility } from "./modules/account/account-helpers";
import { AccountForm } from "./modules/account/AccountForm";

const accountCreationForm = document.querySelector(".account-form") as HTMLFormElement | null;

if (accountCreationForm) {
    if (!(typeof window.CustomEvent === "function")) {
        // @ts-ignore
        import(/* webpackChunkName: "ce-polyfill" */ "./modules/polyfills/ce-polyfill.js").then((customEvent) => customEvent.default());
    }

    new AccountForm(accountCreationForm);

    // Listen for onload function call from the recaptcha script
    (window as any).loadAccountRecaptcha = () => {
        // Create and dispatch an event to render the Recaptcha
        const event = new CustomEvent("loadAccountRecaptcha");

        window.dispatchEvent(event);
    };
}

if (document.querySelector(".wp-hide-pw")) {
    togglePasswordVisibility();
    document.querySelector(".wp-hide-pw")!.addEventListener("click", togglePasswordVisibility);
}

// Reset password input to "password" type on submit
document.querySelector(".reset-password__form")?.addEventListener("submit", () => ((document.querySelector(".js-password-input") as HTMLInputElement).type = "password"));
